import { getStoreId } from "$/hooks/use-store-information"
import storeQueries from "$/lib/queries/store-queries"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/bikes-for-sale")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    const store = storeId
      ? await queryClient.ensureQueryData(storeQueries.detail(storeId))
      : null
    if (!store?.canPublishBikeForSale) {
      throw redirect({ to: "/", replace: true })
    }
    return { crumb: "alfred.pages.bikesForSale.crumbs.bikesForSale" }
  },
})
